import React, { useState } from "react";

const EditStory = () => {
  const [sectionHeader, setSectionHeader] = useState("");
  const [paragraphs, setParagraphs] = useState([""]);

  const handleSectionHeaderChange = (e) => setSectionHeader(e.target.value);

  const handleParagraphChange = (index, e) => {
    const newParagraphs = [...paragraphs];
    newParagraphs[index] = e.target.value;
    setParagraphs(newParagraphs);
  };

  const handleAddParagraph = () => setParagraphs([...paragraphs, ""]);
  const handleRemoveParagraph = (index) => setParagraphs(paragraphs.filter((_, i) => i !== index));

  const handleSaveChanges = () => {
    const data = { sectionHeader, paragraphs };
    console.log("Saving story data:", data);
    // Replace with API call or other save logic
  };

  return (
    <div className="edit-about edit-story">
      <h2>Edit Story Section</h2>

      {/* Section Header Input */}
      <div className="form-group">
        <label htmlFor="sectionHeader">Section Header</label>
        <input
          type="text"
          id="sectionHeader"
          value={sectionHeader}
          onChange={handleSectionHeaderChange}
          placeholder="Enter section header"
        />
      </div>

      {/* Paragraphs */}
      <div className="form-group">
        <label>Story Paragraphs</label>
        {paragraphs.map((text, index) => (
          <div key={index} className="paragraph-group">
            <textarea
              value={text}
              onChange={(e) => handleParagraphChange(index, e)}
              placeholder="Enter story paragraph"
            ></textarea>
            {index > 0 && (
              <button
                type="button"
                onClick={() => handleRemoveParagraph(index)}
                className="remove-paragraph-btn"
              >
                Remove
              </button>
            )}
          </div>
        ))}
        <button type="button" onClick={handleAddParagraph} className="add-paragraph-btn">
          Add More Paragraph
        </button>
      </div>

      {/* Save Changes Button */}
      <button type="button" onClick={handleSaveChanges} className="save-btn">
        Save Changes
      </button>
    </div>
  );
};

export default EditStory;
